/*

GLOBAL SCRIPTS	
	
These functions make sure WordPress
and Foundation play nice together.
*/
//(function($){})(jQuery);

var window = jQuery(window);
jQuery(document).ready(function($) {	
	//initDebugin();
	initJsGlobal();
	initNavigation();
	initGalleries();
	initReplaceFancybox();		
	clickToExpand();
	//initBrowserExposure();
	if(jQuery('#off-canvas').length){
		initOffCanvasSwitcher();	
	}
	passFormTitleAsFormName();
	// Check on scroll and on initial load
	jQuery(window).scroll(checkVisibility);
	checkVisibility();
	// Center active tab on load
	centerActiveTab();
	
	jQuery(window).scroll(checkFadeInVisibility);
	checkFadeInVisibility();
	
	// Listen for clicks on tab titles to make them active
	jQuery('.kt-title-item').on('click', function () {
		// Remove active class from currently active item
		jQuery('.kt-tab-title-active').removeClass('kt-tab-title-active');
		// Add active class to clicked item
		jQuery(this).addClass('kt-tab-title-active');
		// Center the newly active tab
		centerActiveTab();
	});
});

var Swiper;
var Foundation;

// Required for GA4 form_name parameter
function passFormTitleAsFormName(){
	// Find all Gravity Forms on the page
	jQuery('.gform_wrapper form').each(function(index) {
		// Look for the nearest gform heading for the form title
		var formTitle = jQuery(this).parent().find('.gform_heading .gform_title').text();
		// Look for the form ID
		var formID = jQuery(this).attr('id');
		
		// Set the 'name' attribute of the form to a combination of title and ID
		var combinedName = formTitle + ' - ' + formID;
		jQuery(this).attr('name', combinedName);
		
		//console.log(combinedName);
	}); 
}
// used to console log screen breakpoint changes while developing themes
function initDebugin() {
	var currentBreakpoint = Foundation.MediaQuery.current;
	//console.log('the current breakpoint is ' + currentBreakpoint);
	jQuery(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
		  // newSize is the name of the now-current breakpoint, oldSize is the previous breakpoint
	});
	
	jQuery(document).on('show.zf.dropdownMenu', function(ev, $el) {
   	 	console.log('dropdown has been opened');
	});
}

function initJsGlobal() {
	const $window = jQuery(window); // Cache window object
	const $document = jQuery(document); // Cache document object
	
	// 1. Caching Selectors
	const $emptyParagraphs = jQuery('.accordion p:empty, .orbit p:empty');
	const $youtubeVimeoEmbeds = jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]');
	const $lowerBar = jQuery('.lower-bar');
	const $stickyWrapper = jQuery('.sticky-wrapper-navigation');
	const $blockquotes = jQuery('blockquote');
	const $h2Headings = jQuery('h2:not(.remove-underline):not(.jump-to-section-heading):not(.is-style-remove-underline-heading):not(.gform_title)');
	const $buttonsWithArrows = jQuery('.wp-block-button:not(.is-style-button-has-play-video) a, a.wp-block-post-excerpt__more-link, a.button.is-style-secondary-button, a.phone-number.button, a.back-to-top, a.nav-cta-btn');
	const $linksWithArrows = jQuery('.is-style-primary-link-w-arrow a, .is-style-white-link-w-arrow a, .is-style-secondary-link-w-arrow a, .post-link.is-style-primary-link-w-arrow, a.is-style-white-link-w-arrow');
	const $submenuItems = jQuery('.navigation-bar ul li ul.menu-depth-1 li');
	const $floatingImageAnimations = jQuery('.float-image-w-animation');
	const $hpSubBanner = jQuery('.hp-sub-banner');
	const $customNumberedLists = jQuery('.is-style-custom-numbered-list');
	const $bodyWrapper = jQuery('.body-wrapper'); // Cache .body-wrapper
	const $innerBanner = jQuery('.inner-banner'); // Cache .inner-banner
	
	let isScrolling = false;
	
	
	// 2. Actions on Cached Elements
	$emptyParagraphs.remove();
	$lowerBar.removeClass('wait-js');
	$stickyWrapper.removeClass('wait-js');
	$blockquotes.prepend('<div class="svg-quote"><svg id="Component_2_1" data-name="Component 2 – 1" xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47"><text id="_" data-name="“" transform="translate(0 108)" font-size="140" font-family="Helvetica"><tspan x="0" y="0">“</tspan></text></svg></div>');
	$h2Headings.wrap('<div class="custom-heading"></div>').parent().append('<span class="underline-border"></span>');
	$buttonsWithArrows.append('<span class="button-arrows"></span>');
	
	
	// 3. Event Handlers with Caching (optimized with each())
	$linksWithArrows.each(function() {
	  jQuery(this).append('<span class="link-arrows"></span>');
	});
	
	$submenuItems.hover(
	  function () { jQuery(this).addClass('hovered'); },
	  function () { jQuery(this).removeClass('hovered'); }
	);
	
	// 4. Scroll/Resize Handlers with Caching and Optimization
	function handleScrollResize() {
	  const scrollTop = $window.scrollTop();
	  const bannerHeight = $innerBanner.height();
	  const newTop = Math.max(0, bannerHeight - scrollTop);
	  // Smooth scrolling
	  $bodyWrapper.css('margin-top', newTop + 'px');
	
	  // Check Visibility of Elements
	  checkVisibility(jQuery('.custom-heading')); // Pass cached elements
	  checkFadeInVisibility(jQuery('.has-fade-in')); // Pass cached elements
	}
	
	$window.on('scroll resize', handleScrollResize); // Combine events
	$window.on('load', handleScrollResize); // Also call on load
	
	
	// 5. Floating Image Animation with Caching
	$floatingImageAnimations.each(function () {
	  const $meetDrBlock = jQuery(this);
	  const $doctorBlockFtImage = $meetDrBlock.find('.floating-image-w-animation');
	  const isInPostSidebar = $meetDrBlock.parent('.post-sidebar').length > 0;
	
	  // Set initial position 30px above the container if in post-sidebar
	  if (isInPostSidebar && $window.width() <= 1024) {
		$doctorBlockFtImage.css('transform', 'translateY(-100px)');
	  }
	
	  function adjustFloatingImage() {
		var scrollTop = $window.scrollTop();
		var elementOffset = $meetDrBlock.offset().top;
		var distance = elementOffset - scrollTop;
		var windowHeight = $window.height();
		var elementHeight = $meetDrBlock.outerHeight();
		var imageHeight = $doctorBlockFtImage.outerHeight();
		var isMobile = $window.width() <= 1024; // Adjust this width as per your mobile breakpoint
	
		if (isInPostSidebar && isMobile) {
		  // Ensure the image is correctly positioned on page load for mobile
		  $doctorBlockFtImage.css('transform', 'translateY(-100px)');
		} else if (!isMobile) {
		  // Only apply the floating animation if not on mobile
		  // Check if meet-dr-block is in view
		  if (distance < windowHeight && distance > -elementHeight) {
			var scrollPercent = (windowHeight - distance) / (windowHeight + elementHeight);
			var moveDistance = (scrollPercent * (elementHeight - imageHeight)) / 2; // Adjust for smoother movement
	
			// Ensure the image stays within the container
			var maxMove = (elementHeight - imageHeight) / 2;
			moveDistance = Math.max(-maxMove, Math.min(maxMove, moveDistance));
	
			$doctorBlockFtImage.css('transform', 'translateY(' + moveDistance + 'px)');
		  }
		}
	  }
	
	  $window.on('scroll', adjustFloatingImage);
	  $window.on('resize', adjustFloatingImage);
	
	  // Initial adjustment
	  adjustFloatingImage();
	});
	
	// 6. hp-sub-banner click/hover handling (with caching)
	// hp-sub-banner click/hover handling (with caching)
	if ($hpSubBanner.length > 0) {
	  const $bannerCards = $hpSubBanner.find('.banner-card');
	  const $firstCard = $bannerCards.first();
	
	  function toggleActiveCard(card) {
		$bannerCards.removeClass('is-active-card');
		jQuery(card).addClass('is-active-card');
	  }
	
	  function ensureOneActiveCard() {
		if ($bannerCards.filter('.is-active-card').length === 0) {
		  $firstCard.addClass('is-active-card');
		}
	  }
	
	  function handleResize() {
		const windowWidth = $window.width();
	
		if (windowWidth > 1024) {
		  // Desktop version
		  $bannerCards.off('click mouseenter mouseleave');
	
		  $bannerCards.on({
			mouseenter: function () {
			  toggleActiveCard(this);
			},
			mouseleave: function () {
			  jQuery(this).removeClass('is-active-card');
			  ensureOneActiveCard();
			}
		  });
	
		  // Ensure at least one card is active initially
		  ensureOneActiveCard();
		} else {
		  // Mobile version
		  $bannerCards.off('mouseenter mouseleave');
	
		  $bannerCards.on('click', function () {
			const isActive = jQuery(this).hasClass('is-active-card');
			$bannerCards.removeClass('is-active-card');
			if (!isActive) {
			  jQuery(this).addClass('is-active-card');
			}
		  });
		}
		if (windowWidth > 1280){
			jQuery("body").removeClass('offCanvasOpen');
			jQuery(".hamburger").removeClass("is-active");
			jQuery('.off-canvas-content').removeClass('is-opened'); 
			jQuery('.js-off-canvas-overlay').removeClass('is-visible'); 
		}
	  }
	
	  // Handle initial load
	  handleResize();
	
	  // Handle resize events
	  $window.on('resize', handleResize);
	}

	
	
	// 7. Numbered List Animation with Caching
	if ($customNumberedLists.length > 0) {
	  $window.scroll(function() {
		$customNumberedLists.each(function() {
		 var containerTop = jQuery(this).offset().top;
		 var windowBottom = jQuery(window).scrollTop() + jQuery(window).height();
		 
		 if (windowBottom > containerTop) {
			 jQuery(this).find('li').each(function(i) {
				 jQuery(this).delay(200 * i).animate({ opacity: 1 }, 400); // Animate opacity to 1
			 });
		 }
		});
	  });
	}
}

function checkVisibility() {
	jQuery('.custom-heading').each(function() {
		var $element = jQuery(this);
		var topOfElement = $element.offset().top;
		var bottomOfElement = $element.offset().top + $element.outerHeight();
		var scrollTop = jQuery(window).scrollTop();
		var windowBottom = scrollTop + jQuery(window).height();

		// Check if the element is in view
		if ((topOfElement < windowBottom) && (bottomOfElement > scrollTop)) {
			$element.addClass('in-view');
		} else {
			$element.removeClass('in-view');
		}
	});
}

function centerActiveTab() {
	var $activeTab = jQuery('.kt-tabs-title-list .kt-tab-title-active');
	if ($activeTab.length > 0) {
		var $scrollBox = $activeTab.parent();
		var scrollBoxWidth = $scrollBox.outerWidth();
		var activeTabWidth = $activeTab.outerWidth();
		var activeTabLeft = $activeTab.position().left;

		// Scroll to center the active tab
		$scrollBox.scrollLeft(activeTabLeft - ((scrollBoxWidth / 2) - (activeTabWidth / 2)));
	}
}

function checkFadeInVisibility(){
	
	jQuery('.has-fade-in').each(function() {
		var $element = jQuery(this);
		var topOfElement = $element.offset().top;
		var bottomOfElement = $element.offset().top + $element.outerHeight();
		var scrollTop = jQuery(window).scrollTop();
		var windowBottom = scrollTop + jQuery(window).height();
	
		// Check if the element is in view
		if ((topOfElement < windowBottom) && (bottomOfElement > scrollTop)) {
			$element.addClass('show');
		} else {
			$element.removeClass('show');
		}
	});
	
}

var currentTransition = "",
currentPosition = "";

function initOffCanvasSwitcher() {

	jQuery(window).on("load",function(e){
		var newSize = Foundation.MediaQuery.current;
		
		setOffcanvasPosition(newSize);	
	
	});	
		
	jQuery(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
		// newSize is the name of the now-current breakpoint, oldSize is the previous breakpoint		 
		setOffcanvasPosition(newSize);		  
	});
	
	function setOffcanvasPosition(newSize) {		
		var mobileOffcanvas = jQuery('#off-canvas').data("mobile").split(" "),
		tabletOffcanvas = jQuery('#off-canvas').data("tablet").split(" "),
		offCanvas = jQuery('#off-canvas');
				
		if(newSize == 'xmedium' || newSize == 'medium'){		
			offCanvas.removeClass("position-"+mobileOffcanvas[0]).addClass("position-"+tabletOffcanvas[0]);
			offCanvas.removeClass("is-transition-"+mobileOffcanvas[1]).attr("data-transition", tabletOffcanvas[1]).addClass("is-transition-"+tabletOffcanvas[1]);			
			currentPosition = tabletOffcanvas[0];	
			currentTransition = tabletOffcanvas[1];					
		} 
		
		if(newSize == 'smedium' || newSize == 'small' || newSize == 'xsmall'){		
			offCanvas.removeClass("position-"+tabletOffcanvas[0]).addClass("position-"+mobileOffcanvas[0]);	
			offCanvas.removeClass("is-transition-"+tabletOffcanvas[1]).attr("data-transition", mobileOffcanvas[1]).addClass("is-transition-"+mobileOffcanvas[1]);			
			currentPosition	 = mobileOffcanvas[0];
			currentTransition = mobileOffcanvas[1];					
		}  
	}
		
	// ADDS class name to the body tag to disable scrolling when the offcanvas menu is open and adding transition and positioning class names
	jQuery('#off-canvas').on('opened.zf.offCanvas', function () {
        jQuery("body").addClass('offCanvasOpen');
		var navFixedState = Foundation.MediaQuery.is('xmedium down'),		
		hasIsAnchored = jQuery('.sticky-wrapper-navigation').hasClass('is-anchored');
		
        if(navFixedState && hasIsAnchored ){ jQuery('.sticky-wrapper-navigation').removeClass('is-anchored').addClass('is-stuck');}    
	
		jQuery(".hamburger").addClass("is-active");             
        jQuery('.off-canvas-content').removeClass('is-opened is-open-left has-position-left has-transition-push has-transition-overlap').addClass('is-opened is-open-'+currentPosition+' has-position-'+currentPosition+' has-transition-'+currentTransition);   		
    });
   
    jQuery('#off-canvas').on('close.zf.offCanvas', function () {
	    // Look for .hamburger
		jQuery(".hamburger").removeClass("is-active");
        jQuery("body").removeClass('offCanvasOpen');
        jQuery('.off-canvas-content').removeClass('is-opened is-open-'+currentPosition+' has-position-'+currentPosition);  
    });
}

function initGalleries(){
	jQuery('.imgGalItem').click(function(event) {
			
		var selector = jQuery(this),
			link = selector.attr('data-link'),
			rel  = selector.attr('rel'),
			height = selector.attr('height'),
			width = selector.attr('width'),
			counts = selector.attr('data-groups'),			
			newContent = '<a href="'+link+'" rel="galSlideCell'+rel+'" data-fancybox="group'+counts+'" data-caption="*Individual Results May Vary"><img src="'+link+'" height="+height+" width="+width+"></a>',
			containerHeight = jQuery(".galSlideCell"+rel+" .main-gal-img a").height();		
		
		jQuery(".photoGallery"+rel).removeClass("is-active");
		selector.addClass("is-active");		
			
		jQuery(".galSlideCell"+rel+" .main-gal-img").stop().css({'opacity':'0' , 'height':containerHeight+'px'}).html(function () {				
		 		return newContent;
		    }).animate({
		        opacity: 1
		    },500);	
		    
		setTimeout(function(){jQuery(".galSlideCell"+rel+" .main-gal-img").css('height','auto'); }, 500); 		
		event.preventDefault();	
		return false;
	});	

	jQuery('select#mobile-sorting').on('change', function() {
	  window.location.replace(this.value);
	});
	
}

function initReplaceFancybox(){
	var fancyboxLink = jQuery('.fancy-box a');
	var fancyboxLink2 =  jQuery('.fancybox a');
	var playVideo = jQuery('.is-style-button-has-play-video a');
	var playLink = jQuery('.is-style-play-video-link-w-icon a');
	if(fancyboxLink){
		
		fancyboxLink.attr('data-fancybox', '');
	}
	if(fancyboxLink2){
			
		fancyboxLink2.attr('data-fancybox', '');
	}
	if(playVideo){
			
		playVideo.attr('data-fancybox', '');
	}
	if(playLink){
			
		playLink.attr('data-fancybox', '');
	}

}


function initNavigation() {
	jQuery('.sticky-wrapper-navigation').on('sticky.zf.stuckto:top', function(){
	  	jQuery(this).addClass('shrink');
	}).on('sticky.zf.unstuckfrom:top', function(){
	  	jQuery(this).removeClass('shrink');
	})	
}

function clickToExpand(){	
	var expandTar = jQuery('.is-style-click-to-expand'),
		ehmax = '',
		expandTarBtn = '<a class="expandBtn"><span class="showMe">Click To Expand</span><span class="hideMe">Click To Collapse</span> <i class="rotateMe none fa fa-angle-double-right" aria-hidden="true"></i></a>';
	
	expandTar.wrapInner('<div class="expandrContent"></div>');
	expandTar.append(expandTarBtn);

	jQuery('.expandrContent').each( function(){
		ehmax = jQuery(this).parent().data('eh-max');
		jQuery(this).find('.expandrContent').css('max-height', ehmax);		
		jQuery(this).css('max-height', ehmax );
	});
	
	jQuery('.expandBtn').on('click', function(){
		jQuery(this).find('.rotateMe').toggleClass('none down');
		jQuery(this).find('span').toggleClass('showMe hideMe');
		jQuery(this).parent().find('.expandrContent').toggleClass('expanded');
		jQuery(this).toggleClass('expanded');	
	});
		
}


var navigator;
var DocumentTouch;


//	Animations v1.1, Joe Mottershaw (hellojd)
//	https://github.com/hellojd/animations / https://github.com/Sananes/animations

//	==================================================

//	Visible, Sam Sehnert, samatdf, TeamDF
//	https://github.com/teamdf/jquery-visible/
//	==================================================

	(function($){
		
		$.fn.visible = function(partial,hidden,direction) {
			var $t				= jQuery(this).eq(0),
				t				= $t.get(0),
				$w				= jQuery(window),
				viewTop			= $w.scrollTop(),
				viewBottom		= viewTop + $w.height(),
				viewLeft		= $w.scrollLeft(),
				viewRight		= viewLeft + $w.width(),
				_top			= $t.offset().top,
				_bottom			= _top + $t.height(),
				_left			= $t.offset().left,
				_right			= _left + $t.width(),
				compareTop		= partial === true ? _bottom : _top,
				compareBottom	= partial === true ? _top : _bottom,
				compareLeft		= partial === true ? _right : _left,
				compareRight	= partial === true ? _left : _right,
				clientSize		= hidden === true ? t.offsetWidth * t.offsetHeight : true;
				direction		= (direction) ? direction : 'both';

			if(direction === 'both')
				return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop)) && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
			else if(direction === 'vertical')
				return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop));
			else if(direction === 'horizontal')
				return !!clientSize && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
		};
		

		$.fn.fireAnimations = function(options) {
			function animate() {
				if (jQuery(window).width() >= 0) {
					jQuery('.animate__animated').each(function(i, elem) {
							elem = jQuery(elem);
							//var	type = jQuery(this).attr('data-anim-type'),
							//delay = jQuery(this).attr('data-anim-delay');

						if (elem.visible(true)) {
							setTimeout(function() {
								elem.addClass('trigger');
							}, 100);
						} 
					});
				} else {
					jQuery('.animate__animated').each(function(i, elem) {
							elem = jQuery(elem);
						var	type = jQuery(this).attr('data-anim-type'),
							delay = jQuery(this).attr('data-anim-delay');

							setTimeout(function() {
								elem.addClass(type);
							}, delay);
					});
				}
			}

			jQuery(document).ready(function() {
				jQuery('html').removeClass('no-js').addClass('js');

				animate();
			});

			jQuery(window).scroll(function() {
				animate();

				if (jQuery(window).scrollTop() + jQuery(window).height() == jQuery(document).height()) {
					animate();
				}
			});
		};

		jQuery('.animate').fireAnimations();

	})(jQuery);
		
	var	triggerClasses = 'flash strobe shake bounce tada wave spin pullback wobble pulse pulsate heartbeat panic explode';
		
	var	classesArray = [];
		classesArray = triggerClasses.split(' ');

	var	classAmount = classesArray.length;
	var type;
	
	function randomClass() {
		var	random = Math.ceil(Math.random() * classAmount);

		type = classesArray[random];

		return type;
	}

	function triggerOnce(target, type) {
		if (type == 'random') {
			type = randomClass();
		}

		jQuery(target).removeClass('trigger infinite ' + triggerClasses).addClass('trigger').addClass(type).one('webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend', function() {
			jQuery(this).removeClass('trigger infinite ' + triggerClasses);
		});
	}

	function triggerInfinite(target, type) {
		if (type == 'random') {
			type = randomClass();
		}

		jQuery(target).removeClass('trigger infinite ' + triggerClasses).addClass('trigger infinite').addClass(type).one('webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend', function() {
			jQuery(this).removeClass('trigger infinite ' + triggerClasses);
		});
	}

	jQuery(window).resize(function() {
		jQuery('.animate').fireAnimations();
	});


function initBrowserExposure() {
	


	var uaMatch = '', prefix = '';

	if (navigator.userAgent.match(/Windows/))
	{
	  jQuery('html').addClass('windows');
	}
	else if (navigator.userAgent.match(/Mac OS X/))
	{
	  jQuery('html').addClass('macOs');
	}
	else if (navigator.userAgent.match(/X11/))
	{
	  jQuery('html').addClass('x11');
	}

	var supports = (function() {
	var d = document.documentElement,
		c = "ontouchstart" in window || navigator.msMaxTouchPoints;
	if (c) {
		d.className += " touch";
		return {
			touch: true
		}
	} else {
		d.className += " no-touch";
		return {
			touch: false
		}
	}
	})();

	// browser
	if (navigator.userAgent.match(/Chrome/))
	{
	  uaMatch = ' Chrome/';
	  prefix = 'chrome';
	}
	else if (navigator.userAgent.match(/Safari/))
	{
	  uaMatch = ' Version/';
	  prefix = 'safari';
	}
	else if (navigator.userAgent.match(/Firefox/))
	{
	  uaMatch = ' Firefox/';
	  prefix = 'firefox';
	}
	else if (navigator.userAgent.match(/MSIE/))
	{
	  uaMatch = ' MSIE ';
	  prefix = 'x-msie';
	}
	// add result preifx as browser class
	if (prefix)
	{
	  jQuery('html').addClass(prefix);	   
	}

}

// Get IE or Edge browser version
var version = detectIE();

if (version === false) {
  jQuery('html').addClass('not-ie-edge');
} else if (version >= 12) {
   jQuery('html').addClass('edge edge-'+ version);
} else {
   jQuery('html').addClass('ie ie-'+ version);
}

// add details to debug result
//document.getElementById('details').innerHTML = window.navigator.userAgent;

/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
 
function detectIE() {
  var ua = window.navigator.userAgent;

  // Test values; Uncomment to check result …

  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
  
  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
  
  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
  
  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
	// IE 10 or older => return version number
	return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
	// IE 11 => return version number
	var rv = ua.indexOf('rv:');
	return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
	// Edge (IE 12+) => return version number
	return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}